export const containsValidTargetClass = (validClasses, target) => {
  // for use in event handlers - returns true if event target has a matching class in the supplied validClasses array
  let validClick = false

  validClasses?.forEach(validClass => {
    if (target && target?.contains(validClass) && validClick === false) {
      validClick = true
    }
  })
  return validClick
}
